import Vue from 'vue';

const user = {
  name: null,
  permissions: [],
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const marketInsights: any[] = [];
const seminarEntries: any[] = [];

const state = Vue.observable({
  user, marketInsights, seminarEntries,
});
export default state;
